import React, { useState, useEffect } from 'react';

const LicenseInput = ({ initialValue, onBlurSave, inputHeight }) => {
  const [value, setValue] = useState(initialValue || '');

  useEffect(() => {
    setValue(initialValue || '');
  }, [initialValue]);

  return (
    <input
      type="text"
      value={value}
      maxLength={7}
      onChange={(e) => {
        console.log('e', e.target.value);
        setValue(e.target.value);
      }}
      onBlur={() => onBlurSave && onBlurSave(value)}
      style={{
        width: '100%',
        height: inputHeight,
        padding: '4px',
        fontSize: '11px',
        border: '1px solid #E1E4EA',
        borderRadius: '4px',
        color: '#131517',
        fontFamily: 'Averta Light',
      }}
    />
  );
};

export default LicenseInput;
